// Core imports
import * as React from 'react';
import LocaleFormatting from 'src/translation/localeFormating';

// Components imports
import Input from 'src/components/common/Input';

// Models imports
import InvoiceModel from 'src/model/invoice.model';
import { IInvoicePaymentData } from '../PaymentMode/PaymentModeMobile';

// Style and misc imports
import './InvoiceToPay.scss';

class InvoiceToPay extends React.Component<
  IInvoiceToPayProps,
  IInvoiceToPayState
> {
  constructor(props: IInvoiceToPayProps) {
    super(props);

    this.state = {
      expandedMode: false,
      paymentAmount: 0,
      remaining: '',
      notes: ''
    };
  }

  /* 
    handlePaymentAmount
   */
  private handlePaymentAmount = (event: any) => {
    const value = event.target.value;
    let maxPayment = 0;
    let remaining = 0;
    let payment = 0;
    if (this.props.invoice.remainingAmount < 0) {
      maxPayment = this.props.invoice.remainingAmount;
      remaining =
        maxPayment -
        (value >= maxPayment && value <= 0
          ? value
          : value === '-'
          ? 0
          : maxPayment);
      payment =
        value >= maxPayment && value <= 0
          ? value
          : value === '-'
          ? '-'
          : maxPayment;
    } else {
      maxPayment = this.props.invoice.remainingAmount;
      remaining =
        ((value <= maxPayment ? value : maxPayment) - maxPayment) * -1;
      payment = value <= maxPayment && value >= 0 ? value : maxPayment;
    }

    this.setState(
      {
        paymentAmount: payment,
        remaining: remaining.toString()
      },
      () => {
        this.changeSelectedMode();
        const paymentData: IInvoicePaymentData = {
          transactionId: this.props.invoice.transactionId,
          invoiceDate: this.props.invoice.invoiceDate,
          invoiceNumber: this.props.invoice.invoiceNumber,
          orderNumber: this.props.invoice.orderNumber,
          payment: this.state.paymentAmount,
          remaining: parseFloat(this.state.remaining),
          total: this.props.invoice.remainingAmount,
          notes: this.state.notes
        };
        this.props.onDataChange(paymentData);
      }
    );
  };

  /* 
    handleNotes
   */
  private handleNotes = (notes: string) => {
    this.setState(
      {
        notes
      },
      () => {
        const paymentData: IInvoicePaymentData = {
          transactionId: this.props.invoice.transactionId,
          invoiceDate: this.props.invoice.invoiceDate,
          invoiceNumber: this.props.invoice.invoiceNumber,
          orderNumber: this.props.invoice.orderNumber,
          payment: this.state.paymentAmount,
          remaining: parseFloat(this.state.remaining),
          total: this.props.invoice.remainingAmount,
          notes: this.state.notes
        };
        this.props.onDataChange(paymentData);
      }
    );
  };

  /* 
    changeSelectedMode
   */
  private changeSelectedMode = () => {
    if (
      parseFloat(this.state.remaining) === 0 ||
      this.state.paymentAmount.toString() === '' ||
      this.state.paymentAmount === 0
    ) {
      this.setState({ expandedMode: false });
    } else {
      this.setState({ expandedMode: true });
    }
  };

  public componentDidMount() {
    this.setState({ paymentAmount: this.props.invoice.remainingAmount }, () => {
      const paymentData: IInvoicePaymentData = {
        transactionId: this.props.invoice.transactionId,
        invoiceDate: this.props.invoice.invoiceDate,
        invoiceNumber: this.props.invoice.invoiceNumber,
        orderNumber: this.props.invoice.orderNumber,
        payment: this.state.paymentAmount,
        remaining: parseFloat(this.state.remaining),
        total: this.props.invoice.remainingAmount,
        notes: this.state.notes
      };
      this.props.onDataChange(paymentData);
    });
  }

  public render() {
    const { t, invoice } = this.props;
    const selectedFlag = this.state.expandedMode ? 'selected' : '';
    return (
      <div className={`rp-invoice-to-pay ${selectedFlag}`}>
        <div className="rp-invoice-to-pay--short-invoice">
          <div className="info-block invoice-number">
            <span className="title">{t('invoices.invoiceNumberShort')}</span>
            <span className="value">{invoice.invoiceNumber}</span>
          </div>
          <div className="info-block total-amount">
            <span className="title">{t('invoices.totalAmount')}</span>
            <span className="value">
              {LocaleFormatting.formatCurrency(invoice.remainingAmount)}
            </span>
          </div>
          <div className="info-block payment-amount">
            <span className="title">{t('invoices.paymentAmount')}</span>
            <input
              className="value-input"
              type="text"
              value={this.state.paymentAmount}
              onChange={this.handlePaymentAmount}
              onClick={event => {
                event.stopPropagation();
              }}
            />
          </div>
        </div>
        <div className={`rp-invoice-to-pay--expanded-invoice ${selectedFlag}`}>
          <div className="info-block remaining-amount">
            <span className="title">{t('invoices.remainingAmount')}</span>
            <span className="value">
              {LocaleFormatting.formatCurrency(
                parseFloat(this.state.remaining)
              )}
            </span>
          </div>
          <div className="notes">
            {parseFloat(this.state.paymentAmount.toString()) <
              parseFloat(invoice.remainingAmount.toString()) &&
            parseFloat(invoice.remainingAmount.toString()) > 0 ? (
              <Input
                className="note-input"
                type="text"
                value={this.state.notes}
                onChange={this.handleNotes}
                invalid={!this.state.notes}
                invalidMessage={'Required field.'}
                label={t('common.notes')}
              />
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

export default InvoiceToPay;

interface IInvoiceToPayProps {
  onDataChange(invoice: IInvoicePaymentData): void;
  t: any;
  invoice: InvoiceModel;
}

interface IInvoiceToPayState {
  expandedMode: boolean;
  paymentAmount: number;
  remaining: string;
  notes: string;
}
